module.exports = __webpack_public_path__ + "img/gap_logo@2x.1afebd97.png";